import { adminAPI } from "./api/admin/adminApi";
import { authApi } from "./api/auth/authApi";
import { businessPermitsAPI } from "./api/admin/businessPermitApi";

export const createApi = () => ({
  auth: authApi,
  admin: adminAPI,
  businessPermits: businessPermitsAPI
})
